import { createSlice } from "@reduxjs/toolkit";
import {
  fetchNotifications,
  fetchNotificationById,
  deleteNotification,
  markNotificationRead
} from "./notificationThunks";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    list: [],
    selected: null,
    unreadCount: 0,
    loading: false
  },
  reducers: {
    clearSelected: (state) => {
      state.selected = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.list = action.payload.data.notifications;
        state.unreadCount = action.payload.unreadCount;
      })
      .addCase(fetchNotificationById.fulfilled, (state, action) => {
        state.selected = action.payload;
      })
      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.list = state.list.filter(n => n._id !== action.payload);
        state.selected = null;
      })
      .addCase(markNotificationRead.fulfilled, (state, action) => {
        const notif = state.list.find(n => n._id === action.payload);
        if (notif) notif.status = "read";
        state.unreadCount -= 1;
      });
  }
});

export const { clearSelected } = notificationSlice.actions;
export default notificationSlice.reducer;
